import FEATURE from './FEATURE';

export default (type) =>
  Object.fromEntries(
    Object.entries(FEATURE)
      .filter(([, v]) => v.type === type)
      .map(([key, { value }]) => [key, value])
  );
